import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import VideoPlayer from '@/components/VideoPlayer.vue'
  import useCourse from '@/composables/useCourse'
  import useVideo from '@/composables/useVideo'
  import { CourseModule } from '@/store/modules/course'
  import useSegment from '@/composables/useSegment'
  import { useRouter } from 'vue-router/composables'
  import useBreakpoint from '@/composables/useBreakpoint'
  import ExamResultsCompletions from '@/components/course/ExamResultsCompletions.vue'
  import useShopifyClient from '@/composables/useShopifyClient'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExamStartPage',
  setup(__props) {

  const router = useRouter()
  const {
    course,
    currentCourseId,
    isCourseExamPaused,
    courseExamId,
    isPurchasedCourse,
    isTrialCourse,
    latestExamCompletionId,
    onKnowledgeCheckInfo,
  } = useCourse()
  const { getPosterImage } = useVideo()
  const { trackPage, pageViewed, examAborted } = useSegment()
  const { isDesktopDevice } = useBreakpoint()
  const { createShopifyCheckout } = useShopifyClient()
  const fetchingCompletionResults = ref(false)
  const fetchingMoreCompletionResults = ref(false)
  const fetchedAllCompletions = ref(false)
  const currentCompletionsPage = ref(1)

  const courseExam = computed(() => course.value?.exam)

  const examResults = computed(() => CourseModule.examResults)

  const startCourseExam = () => {
    router.push({ name: 'CourseExamContent' }).catch(() => {
      return
    })
  }

  const fetchCompletionStatus = () => {
    if (latestExamCompletionId.value) {
      CourseModule.getExamCompletionState(latestExamCompletionId.value)
    }
  }

  const fetchExamResults = () => {
    CourseModule.getExamResults().finally(() => {
      fetchingCompletionResults.value = false
      if (examResults.value && examResults.value.length < 5) {
        fetchedAllCompletions.value = true
      }
    })
  }

  const fetchMoreCompletionResults = () => {
    currentCompletionsPage.value = currentCompletionsPage.value + 1
    fetchingMoreCompletionResults.value = true
    CourseModule.getMoreExamResults(currentCompletionsPage.value)
      .then((resp) => {
        if (resp.no_more_results) {
          fetchedAllCompletions.value = true
        }
      })
      .finally(() => {
        fetchingMoreCompletionResults.value = false
      })
  }

  const abortingExam = ref(false)
  const abortCourseExam = () => {
    abortingExam.value = true
    CourseModule.abortExam({
      selectedAnswerIds: [],
    })
      .then(() => {
        fetchExamResults()
        examAborted(courseExamId.value, currentCourseId.value, course.value!.title)
      })
      .finally(() => {
        abortingExam.value = false
      })
  }

  fetchCompletionStatus()
  fetchExamResults()

  onMounted(() => {
    trackPage('Course Exam Start Page')
    pageViewed('Course Exam Start Page')
  })

return { __sfc: true,router, course, currentCourseId, isCourseExamPaused, courseExamId, isPurchasedCourse, isTrialCourse, latestExamCompletionId, onKnowledgeCheckInfo, getPosterImage, trackPage, pageViewed, examAborted, isDesktopDevice, createShopifyCheckout, fetchingCompletionResults, fetchingMoreCompletionResults, fetchedAllCompletions, currentCompletionsPage, courseExam, examResults, startCourseExam, fetchCompletionStatus, fetchExamResults, fetchMoreCompletionResults, abortingExam, abortCourseExam, computed, onMounted, ref, LoadingSpinner, HTMLRenderer, KetchUpButton, VideoPlayer, useCourse, useVideo, CourseModule, useSegment, useRouter, useBreakpoint, ExamResultsCompletions, useShopifyClient }
}

})